import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import Report006Container from 'app/containers/Report/Report006'

const Report006PageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_006)}</PageTitle>
      <Report006Container />
    </>
  )
}
const Report006Page = memo(Report006PageCpn, isEqual)

export default Report006Page
